import StyledSection from "./styledSection";
import StyledRow from "./styledRow";
import StyledColumn from "./styledColumn";
import StyledHero from "./styledHero";
import StyledNav from "./styledNav";
import StyledHeader from "./styledHeader";
import StyledFooter from "./styledFooter";
import StyledLogoList from "./styledLogoList";

export {
    StyledSection,
    StyledRow,
    StyledColumn,
    StyledHero,
    StyledNav,
    StyledHeader,
    StyledFooter,
    StyledLogoList
}


// WEBPACK FOOTER //
// ./src/styles/styledComponents/blocks/index.js